export default __webpack_public_path__ + "static/2-072713bbdec3127e445b8e16cf7824c1.gif";